import { render, staticRenderFns } from "./overview-table.vue?vue&type=template&id=de8a3ba2&scoped=true&"
import script from "./overview-table.vue?vue&type=script&lang=js&"
export * from "./overview-table.vue?vue&type=script&lang=js&"
import style0 from "./overview-table.vue?vue&type=style&index=0&id=de8a3ba2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de8a3ba2",
  null
  
)

export default component.exports